import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BannerSection = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isEnglish = location.pathname.startsWith("/en");

  // Tomamos el último segmento (después de / o /en)
  const path = location.pathname.split("/").filter(Boolean).pop();

  const banners = {
    // Español
    "quienes-somos": {
      img: "/assets/img/banner-quienes-somos.webp",
      titulo: t("bannersection.quienessomos"),
    },
    "productos": {
      img: "/assets/img/banner-productos.webp",
      titulo: t("bannersection.productos"),
    },
    "nuestra-operacion": {
      img: "/assets/img/banner-nuestra-operacion.webp",
      titulo: t("bannersection.operacion"),
    },

    // Inglés
    "about": {
      img: "/assets/img/banner-quienes-somos.webp",
      titulo: t("bannersection.quienessomos"),
    },
    "products": {
      img: "/assets/img/banner-productos.webp",
      titulo: t("bannersection.productos"),
    },
    "operation": {
      img: "/assets/img/banner-nuestra-operacion.webp",
      titulo: t("bannersection.operacion"),
    },
  };

  const banner = banners[path] || {
    img: "/assets/video/video-home.mp4",
    titulo: isEnglish ? "WELCOME TO YASKIA" : "BIENVENIDO A YASKIA",
  };

  return (
    <div
      className="banner-section"
      style={{ backgroundImage: `url('${banner.img}')` }}
    >
      <h1>{banner.titulo}</h1>
    </div>
  );
};

export default BannerSection;
